import { differenceInCalendarDays } from './datefns';
import pluralize from 'pluralize';

export const getNumberOfNights = ({ checkIn, checkOut }) => {
  const totalDays = differenceInCalendarDays(checkOut, checkIn);
  return pluralize('night', totalDays, true);
};
